import styles from "./Confirm.module.sass";
import cn from "classnames";
import Loader from "../Loader";
import { useUser } from "../../context";
import common from "../../i11/Common";

const Confirm = ({
	className,
	title,
	note,
	onConfirm,
	onCancel,
	isLoading,
	children,
	buttonText,
}) => {
	const { locale } = useUser();
	return (
		<div className={cn(styles.schedule, className)}>
			<div className={cn("title-red", styles.title)}>
				{title || common[locale].sure}
			</div>
			<div className={styles.note}>{note || common[locale].sure}</div>
			{children}
			<div className={styles.btns}>
				<button
					onClick={onConfirm}
					className={cn("button", styles.button, { disabled: isLoading })}
				>
					{isLoading && <Loader className={styles.loader} />}
					<span>{buttonText || common[locale].confirm}</span>
				</button>
				<button
					onClick={onCancel}
					className={cn("button button-stroke-red", styles.button, {
						disabled: isLoading,
					})}
				>
					{common[locale].cancel}
				</button>
			</div>
		</div>
	);
};

export default Confirm;
